import axios from 'axios';

export const logLead = async (lead) => {
  await fetch('https://hooks.zapier.com/hooks/catch/14134856/2scomv0/', {
    method: 'POST',
    body: JSON.stringify(lead),
  });
};
